exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Tabs {\n  box-shadow: inset 0 -1px 0 0 #E2E5E7; }\n  .Tabs .Tab {\n    font: normal 14px/20px \"Graphik\", \"Helvetica\", helvetica, arial, sans-serif;\n    box-sizing: border-box;\n    display: inline-block;\n    padding: 16px 0 14px;\n    margin: 0 24px;\n    transition: border-color 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);\n    border-bottom: 2px solid transparent; }\n  .Tabs .Tab:first-child {\n      margin-left: 0; }\n  .Tabs .Tab:last-child {\n      margin-right: 0; }\n  .Tabs .Tab:not([disabled]) {\n      cursor: pointer; }\n  .Tabs .Tab:active:not([disabled]), .Tabs .Tab.active:not([disabled]), .Tabs .Tab:hover:not([disabled]), .Tabs .Tab.hover:not([disabled]) {\n      color: #3A66E5;\n      border-color: #3A66E5; }\n  .Tabs .Tab[disabled] {\n      color: #A9B0B7; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"config":{"path":"/workspace/config/postcss.config.js"}}!./~/@uniiverse/library/components/tabs/styles.css
// module id = 2235
// module chunks = 3 7 14